import { REORDER_STORE_STATUS, REORDER_STORE_STATUS_SUCCESS, REORDER_STORE_STATUS_ERROR, REORDER_FETCH_MENU, REORDER_FETCH_MENU_ERROR, REORDER_FETCH_MENU_SUCCESS, TENDER_DATA_SET, RE_ORDER_ACCEPTED, RE_ORDER_ACCEPTED_SUCCESS, RE_ORDER_ACCEPTED_ERROR, REORDER_SELECTED_DISPOSITION, SET_REORDER, REORDER_STORE_DISPOSITION, } from '../../constants';
const initialState = {
    isReorderStatusSuccess: false,
    isReorderStatusError: false,
    isReorderStoreStatusLoading: false,
    storeSummary: {},
    response: {},
    recommendedProducts: [],
    error: false,
    flatResponse: {},
    isLoading: false,
    fulfillment: {
        scheduled: {},
    },
    isPaymentAdded: false,
    tenderInfo: { name: '', payload: {} },
    reorderAcceptedLoading: false,
    reorderAccepted: {},
    reOrderError: false,
    reorderSelectedDisposition: '',
    reorder: false,
    reorderDisposition: '',
    reorderGeolocationResult: [],
    reorderStore: {},
};
import { MenuUtils } from '../../utils/MenuUtils';
const { filterCatalogByExclusionAndAvailability, createFlatList, clearMasterList, getAllProductsFromCategories } = MenuUtils;
const reorderReducer = (state = initialState, action) => {
    switch (action.type) {
        case REORDER_STORE_STATUS:
            return {
                ...state,
                isReorderStatusSuccess: false,
                isReorderStatusError: false,
                isReorderStoreStatusLoading: true,
                storeSummary: {},
            };
        case REORDER_STORE_STATUS_SUCCESS:
            // const { response:storeResponse = [] } = action.storeStatus || {};
            return {
                ...state,
                isReorderStatusSuccess: true,
                isReorderStatusError: false,
                isReorderStoreStatusLoading: false,
                // storeSummary: storeResponse[0] || {},
                storeSummary: action.storeStatus,
            };
        case REORDER_STORE_STATUS_ERROR:
            return {
                ...state,
                isReorderStatusSuccess: false,
                isReorderStatusError: true,
                isReorderStoreStatusLoading: false,
                storeSummary: {},
            };
        case REORDER_FETCH_MENU:
            return {
                ...state,
                isLoading: true,
            };
        case REORDER_FETCH_MENU_SUCCESS: {
            const scheduledDateTime = state?.fulfillment?.scheduled ?? {};
            const tenantDateFormat = action.tenantDateFormat;
            const response = filterCatalogByExclusionAndAvailability(action.menuResponse, action.exclusionsResponse, scheduledDateTime, tenantDateFormat);
            const categories = response?.categories?.[0]?.categories ?? [];
            clearMasterList();
            const flatResponse = createFlatList(JSON.parse(JSON.stringify(response) ?? '{}'));
            return {
                ...state,
                response,
                searchResults: response,
                isSearching: false,
                flatResponse,
                data: {
                    products: Object.keys(categories).length ? [...getAllProductsFromCategories(categories)] : [],
                    menu: Object.keys(categories).length ? [...categories] : [],
                    categories: Object.keys(categories).length ? [...categories] : [],
                    filters: [],
                    sortBy: [],
                    dietary: [],
                },
                error: false,
                isLoading: false,
            };
        }
        case REORDER_FETCH_MENU_ERROR:
            return {
                ...state,
                error: true,
                isLoading: false,
            };
        case TENDER_DATA_SET: {
            return {
                ...state,
                tenderInfo: action.tenderInfo,
                isPaymentAdded: action.isPaymentAdded,
            };
        }
        case RE_ORDER_ACCEPTED:
            return {
                ...state,
                reorderAcceptedLoading: true,
                reorderAccepted: {},
                reOrderError: false,
            };
        case RE_ORDER_ACCEPTED_SUCCESS:
            return {
                ...state,
                reorderAcceptedLoading: false,
                reOrderError: false,
                reorderAccepted: action.response,
            };
        case RE_ORDER_ACCEPTED_ERROR:
            return {
                ...state,
                reorderAcceptedLoading: false,
                reOrderError: true,
            };
        case REORDER_SELECTED_DISPOSITION:
            return {
                ...state,
                reorderSelectedDisposition: action.payload.reorderSelectedDisposition,
            };
        case SET_REORDER:
            return {
                ...state,
                reorder: action.payload.reorder,
            };
        case REORDER_STORE_DISPOSITION:
            return {
                ...state,
                reorderDisposition: action.payload?.disposition || '',
                reorderStore: action.payload?.store || {},
                reorderGeolocationResult: action.payload?.geolocationResult || [],
            };
        default:
            return state;
    }
};
export default reorderReducer;
